/**
 * Badge color-coded pour le status d un dossier CEE TRA-EQ-131.
 */

const STATUS_CONFIG = {
  annonce: { label: 'Annonce', cls: 'bg-gray-100 text-gray-700' },
  collecte: { label: 'Collecte en cours', cls: 'bg-orange-50 text-orange-700' },
  pret_generation: { label: 'Pret a generer', cls: 'bg-blue-50 text-blue-700' },
  attente_signature: { label: 'Signature en attente', cls: 'bg-blue-50 text-blue-700' },
  transmis: { label: 'Complet', cls: 'bg-emerald-50 text-emerald-700' },
  depot_cee: { label: 'Attente depot CEE', cls: 'bg-emerald-50 text-emerald-700' },
  logistique: { label: 'Livraison en cours', cls: 'bg-purple-50 text-purple-700' },
  cloture: { label: 'Termine', cls: 'bg-gray-100 text-gray-700' },
  bloque: { label: 'Bloque', cls: 'bg-red-50 text-red-700' },
};

/**
 * @param {{ status: string, blockingReason?: string | null, customLabel?: string | null }} props
 */
export default function StatusBadge({ status, blockingReason, customLabel }) {
  const cfg = STATUS_CONFIG[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  const label = customLabel || cfg.label;
  const isAlert = status === 'bloque' || (blockingReason && status === 'collecte');
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${cfg.cls}`}
      title={blockingReason || undefined}
    >
      {isAlert && <span className="text-red-500">!</span>}
      {label}
    </span>
  );
}
